module.exports = __webpack_public_path__ + "img/truckFrontLeftOutline.d906b16d.svg";